import { classNames } from 'libs/react';
import { useState } from 'libs/react';
import { React } from 'libs/react';
import { ButtonDropdown } from 'components/ButtonDropdown';
import { Requires } from 'components/user/Requires';
import { useDealConfiguratorContext } from '../DealConfigureScreen';
import { DealModalDeleteConfirmation } from './modal/DealModalDeleteConfirmation';
import { Button } from 'components/Button';
import { DealAvailabilityModal } from '../modal/DealAvailabilityModal';
import './DealItemPanelToolBar.scss';
/**
 * @component DealItemPanelToolBar
 * @since 1.0.0
 */
export function DealItemPanelToolBar(props) {
    const { style, item, onChangeProposedItem } = Object.assign({ style: 'normal' }, props);
    const { deal, onItemClone, onItemAlternative, onMoveItem } = useDealConfiguratorContext();
    const [openModalDelete, setOpenModalDelete] = useState(false);
    const [openModalAvailability, setOpenModalAvailability] = useState(false);
    const onCloseModalDelete = () => {
        setOpenModalDelete(false);
    };
    /**
     * @function onManageItem
     * @since 1.0.0
     * @hidden
     */
    const onManageItem = (value) => {
        switch (value) {
            case 'clone':
                onItemClone(item);
                break;
            case 'delete':
                setOpenModalDelete(true);
                break;
            case 'proposed':
                onChangeProposedItem(item, true);
                break;
            case 'alternative':
                onItemAlternative(item);
                break;
            case 'notProposed':
                onChangeProposedItem(item, false);
                break;
            case 'moveUp':
                onMoveItem(item, 'up');
                break;
            case 'moveDown':
                onMoveItem(item, 'down');
                break;
        }
    };
    const dropdown = [];
    if (!item.alternativeTo) {
        if (item.proposed) {
            dropdown.push({
                value: 'notProposed',
                picto: 'plus',
                label: t('Include')
            });
        }
        else {
            dropdown.push({
                value: 'proposed',
                picto: 'heart',
                label: t('Suggest')
            });
        }
        dropdown.push({
            value: 'clone',
            picto: 'clone',
            label: t('Duplicate')
        });
        dropdown.push({
            value: 'alternative',
            picto: 'right-left',
            label: t('Alternative')
        });
    }
    // if more than one item
    if ((deal === null || deal === void 0 ? void 0 : deal.items) && deal.items.length > 1) {
        // If item is not the first one
        if ((deal === null || deal === void 0 ? void 0 : deal.items) && deal.items.indexOf(item) > 0) {
            dropdown.push({
                value: 'moveUp',
                picto: 'arrow-up',
                label: t('Move up')
            });
        }
        // If item is not the last one
        if ((deal === null || deal === void 0 ? void 0 : deal.items) && deal.items.indexOf(item) < deal.items.length - 1) {
            dropdown.push({
                value: 'moveDown',
                picto: 'arrow-down',
                label: t('Move down')
            });
        }
    }
    dropdown.push({
        value: 'delete',
        picto: 'times',
        label: t('Remove')
    });
    const className = classNames('deal-item-panel-tool-bar', 'deal-item-panel-tool-bar--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "deal-item-panel-tool-bar-item" },
            React.createElement("div", { className: "deal-item-panel-tool-bar-action" },
                React.createElement(Requires, { permission: "calendar.availability.check" },
                    React.createElement("div", { className: "deal-availability-tooltip" },
                        React.createElement(Button, { style: "picto", size: "small", className: "deal-item-panel-tool-bar-availability-button", picto: "calendar-check", onPress: () => setOpenModalAvailability(true) }),
                        React.createElement("span", { className: "deal-availability-tooltip-value" }, t('Check availability')))),
                React.createElement(ButtonDropdown, { options: dropdown, onSelect: onManageItem }))),
        openModalDelete && (React.createElement(DealModalDeleteConfirmation, { type: 'item', item: item, onClose: onCloseModalDelete, deleteConfirmationMessage: `${t('Delete')} ${item.item.title}?` })),
        openModalAvailability && (React.createElement(DealAvailabilityModal, { deal: deal, onClose: () => setOpenModalAvailability(false), saleItemId: item.item.id }))));
}
